import { BorrowerModel } from '../../cmg-1003/models';
import { Models } from '../../pipeline/models/global.models';

export const openEmailWindow = (email: string): void => {
  if (email) {
    window.open(`mailto:${email}`);
  }
};

export const openEmail = (emailTo: string[], subject: string, body?: string): void => {
  const toEmailLine = emailTo?.filter((t) => !!t).join(';');
  let link = `mailto:${toEmailLine}?subject=${subject}`;
  if (body) {
    link += `&body=${body}`;
  }
  window.open(link);
};

export const openBorrowersEmail = (borrowers: BorrowerModel[] | Models.Borrower[], fileName: string, address: string): void => {
  const emailTo = borrowers.map((b) => {
    const email = (b as Models.Borrower)?.emailAddress ?? (b as BorrowerModel)?.email;
    return email?.trim();
  });
  const subject = `Loan Update for ${borrowers[0]?.lastName} File | ${address ? address : '--'} | Loan #${fileName}`;

  let body = 'Hello ';
  borrowers.forEach((b, index) => {
    body += b.nickName ? b.nickName : b.firstName;
    if (borrowers.length === 2 && index === 0) {
      body += ' %26 ';
    } else if (borrowers.length >= 2 && index === borrowers.length - 2) {
      body += ', %26 ';
    } else {
      body += ', ';
    }
  });

  openEmail(emailTo, subject, body);
};

export const openBorrowersEmailLoanApplication = (borrowers: Models.Borrower[], loanApplicationNumber: string): void => {
  const emailTo: string[] = [];
  const primaryBorrower = borrowers?.find((b) => b.isPrimary);
  const coBorrower = borrowers?.find((b) => !b.isPrimary);
  const subjectPropertyAddress = primaryBorrower?.currentAddress ? formatAddress(primaryBorrower.currentAddress) : 'Unknown Address';
  const subject = `Loan Application Update for ${primaryBorrower?.lastName} | ${subjectPropertyAddress} | Application #${loanApplicationNumber}`;
  emailTo.push(primaryBorrower?.emailAddress);

  let body = 'Hello ';
  body += primaryBorrower?.firstName;
  if (coBorrower?.isActive) {
    body += coBorrower.firstName ? ` %26 ${coBorrower.firstName}` : '';
    emailTo.push(coBorrower.emailAddress);
  }
  body += ', ';

  openEmail(emailTo, subject, body);
};

export const formatAddress = (address: Models.PropertyAddress): string => {
  const { addressLine1, addressLine2, city, state, zipCode } = address;
  const addressParts: string[] = [];

  if (addressLine1) {
    addressParts.push(addressLine1);
  }

  if (addressLine2) {
    addressParts.push(addressLine2);
  }

  if (city) {
    addressParts.push(city);
  }

  if (state || zipCode) {
    const stateZip = [state, zipCode].filter((part) => part).join(' ');
    addressParts.push(stateZip);
  }

  return addressParts.length ? addressParts.join(', ') : 'Unknown Address';
};
